<template>
  <div class="container">
    <head-nav-bar title="会员类型详情" :fixed="true"> </head-nav-bar>
    <div class="mt-header-nav">
      <van-tabs v-model="activeTab">
        <van-tab title="基本信息">
          <cell-box style="padding: 0.3rem 0;" :column="1" labelAlign="right">
            <cell-item label="状态：">
              <template #value>
                <van-tag v-if="info.MemberCardType.Status == '1'" type="success"
                  >启用</van-tag
                >
                <van-tag v-else type="danger">禁用</van-tag>
              </template>
            </cell-item>
            <cell-item label="代码：" :value="info.MemberCardType.Code" />
            <cell-item label="卡类名称：" :value="info.MemberCardType.Name" />
            <cell-item
              label="初始密码："
              :value="info.MemberCardType.InitialPwd"
            />
            <cell-item
              label="退房时间："
              :value="info.MemberCardType.CheckoutTime"
            />
            <cell-item label="有效日期：">
              <template #value>
                {{ info.MemberCardType.StartTime }} -
                {{ info.MemberCardType.EndTime }}
              </template>
            </cell-item>
          </cell-box>
          <div class="card">
            <div class="card-title">适用酒店</div>
            <div class="card-content">
              <div
                class="tag-list"
                v-if="info.MemberCardType && info.MemberCardType.ApplyCompanys"
              >
                <div
                  class="tag-item"
                  v-for="(item, index) in info.MemberCardType.ApplyCompanys"
                  :key="index"
                >
                  <div class="text">{{ item.ComapnyName }}</div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="充值方案">
          <div class="card">
            <div class="card-title">积分规则</div>
            <div class="card-content">
              <cell-box
                style="padding: 0.3rem 0;"
                :column="1"
                labelAlign="right"
              >
                <cell-item label="状态：">
                  <template #value>
                    <van-tag
                      v-if="info.RechargePlanList.Status == '1'"
                      type="success"
                      >启用</van-tag
                    >
                    <van-tag v-else type="danger">禁用</van-tag>
                  </template>
                </cell-item>
                <cell-item label="代码：" :value="info.RechargePlanList.Code" />
                <cell-item
                  label="方案名称："
                  :value="info.RechargePlanList.Name"
                />
                <cell-item label="充值分类：" value="金额充值" />
                <cell-item
                  label="金额赠送方式："
                  :value="
                    info.RechargePlanList.AmountPresentId == 1
                      ? '比例'
                      : '固定金额'
                  "
                />
                <cell-item
                  label="赠送金额比例："
                  :value="
                    info.RechargePlanList.PresentAmount
                      ? info.RechargePlanList.PresentAmount
                      : 0 + '%'
                  "
                />
                <cell-item
                  label="积分赠送方式："
                  :value="
                    info.RechargePlanList.PointPresentId == 1
                      ? '比例'
                      : '固定积分'
                  "
                />
                <cell-item
                  label="赠送积分比例："
                  :value="
                    info.RechargePlanList.PresentPoint
                      ? info.RechargePlanList.PresentPoint
                      : 0 + '%'
                  "
                />
              </cell-box>
            </div>
          </div>
          <div class="card">
            <div class="card-title">积分规则</div>
            <div class="card-content">
              <cell-box
                style="padding: 0.3rem 0;"
                :column="2"
                labelAlign="right"
              >
                <cell-item
                  label="积分类别："
                  :value="info.PointPlanList.CanPoint == 1 ? '付款' : '消费'"
                />
                <cell-item
                  label="四舍五入："
                  :value="
                    info.RechargePlanList.RuleState == 1 ? '取整' : '四舍五入'
                  "
                />
                <cell-item label="每消费1元产生：">
                  <template #value>
                    {{ info.PointPlanList.CanPoint }} 分
                  </template>
                </cell-item>
              </cell-box>
            </div>
          </div>
        </van-tab>
        <van-tab title="优惠方案">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in info.DiscountPlanList"
              :key="index"
              :title="item.CompanyName"
              :value="item.PriceCodeName"
            />
          </van-cell-group>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { getMemberTypeInfo } from "@/api/member.js";
import { CellBox, CellItem } from "@/components/cell";
import { Button, Panel, Notify, Tab, Tabs, Tag, Cell, CellGroup } from "vant";

export default {
  components: {
    [Button.name]: Button,
    [Panel.name]: Panel,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Tag.name]: Tag,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    CellBox,
    CellItem,
  },
  data() {
    return {
      activeTab: "",
      info: {
        MemberCardType: {},
        PointPlanList: [],
        RechargePlanList: [],
        DiscountPlanList: [],
      },
    };
  },
  created() {
    const id = this.$route.query.Id;
    if (!id) {
      Notify("缺少必要参数!");
      setTimeout(() => {
        this.$router.go(-1);
      }, 2000);
      return false;
    }
    this.getInfo(id);
  },
  methods: {
    getInfo(id) {
      getMemberTypeInfo({ Id: id }).then(res => {
        if (
          res.Data &&
          res.Data.RechargePlanList &&
          res.Data.RechargePlanList.length
        ) {
          res.Data.RechargePlanList = res.Data.RechargePlanList[0];
        }
        if (
          res.Data &&
          res.Data.PointPlanList &&
          res.Data.PointPlanList.length
        ) {
          res.Data.PointPlanList = res.Data.PointPlanList[0];
        }
        //处理 优惠方案的甲类名称
        if (
          res.Data &&
          res.Data.DiscountPlanList &&
          res.Data.DiscountPlanList.length
        ) {
          const DiscountPlanList = res.Data.DiscountPlanList.map(item => {
            item.PriceCodeName = "暂无";
            if (
              item.PriceCodeId &&
              item.PriceCodeList &&
              item.PriceCodeList.length
            ) {
              //存在价类
              const priceCodeIndex = item.PriceCodeList.findIndex(
                p => p.Id == item.PriceCodeId,
              );
              if (priceCodeIndex > -1) {
                item.PriceCodeName = item.PriceCodeList[priceCodeIndex].Text;
              }
            }
            return item;
          });
          res.Data.DiscountPlanList = DiscountPlanList;
        }
        console.log(res.Data.DiscountPlanList);

        this.info = res.Data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-tab {
  border-bottom: 1px solid #f1f1f1;
}
/deep/ .cell-item .title {
  width: 2.8rem;
}
.tag-list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  padding: 10px;
  .tag-item {
    padding: 3px;
    .text {
      padding: 6px 10px;
      background: #f1f1f1;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }
  }
}
</style>
